import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import Grid from '@mui/material/Grid'
import { Button } from '../../features/section-components/Button'
import { TextboxMobile } from '../../features/section-components/Textbox'
import MarginWrapper from '../../features/wrappers/MarginWrapper'
import styles from './EditSecondaryEmail.module.scss'
import { SectionHeader } from '../../features/section-components/SectionHeader'
import JNJFooter from '../../features/jnj-footer/JNJFooter'

import { LoadingIcon } from '../../features/section-components/LoadingIcon'
import { setSecondaryEmail } from './editSecondaryEmailSlice'
import { selectUserObject } from '../../features/user/userSlice'

const hasWindow = typeof window !== 'undefined'

const HTMLElementType = hasWindow && window.HTMLElement
  ? window.HTMLElement
  : function HTMLElement() { }

const HTMLInputElementType = hasWindow && window.HTMLInputElement
  ? window.HTMLInputElement
  : HTMLElementType

function EditSecondaryEmailMobile({
  t,
  userFields,
  validFields,
  handleBlur,
  handleSubmit,
  isFormValid,
  onCancel,
  status,
  handleChange,
  secondaryEmailRef
}) {
  const loading = status === 'loading'
  const profile = useSelector(selectUserObject)
  const dispatch = useDispatch()

  useEffect(() => () => {
    dispatch(setSecondaryEmail(profile.secondEmail || ''))
  }, [dispatch, profile.secondEmail])

  return (

    <MarginWrapper>
      <LoadingIcon isLoading={loading}>
        <div className={styles['edit-name-mobile']} />
        <div className={styles['edit-name-container-mobile']}>
          <div className={styles['back-home-section']}>
            <Link
              to="/account"
              style={{
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
              }}
              color="black"
            >
              <ArrowBackIosIcon
                className={styles['home-icon']}
                fontSize="inherit"
              />
              <div className={styles['home-text']}>{t('account-tab')}</div>
            </Link>
          </div>
          <SectionHeader text={t('label-second-email-optional')} size="medium" />
          <span className={styles['form-secondary-text-head']}>
            {t('support-text-second-email')}
          </span>

          <div className={styles['form-field']}>
            {/* <span className={styles['form-label']}>
              {t('support-text-second-email')}
            </span> */}
            <label htmlFor="secondaryEmail-textbox" className={styles['form-label']}>{t('edit-secondary-email')}</label>
            <span className={styles['form-secondary-text']}>{t('please-enter-your-new-email')}</span>
            <TextboxMobile
              label="secondaryEmail"
              inputRef={secondaryEmailRef}
              value={userFields.secondEmail}
              name="secondEmail"
              onChange={(e) => {
                handleChange({
                  target: {
                    name: 'secondEmail',
                    value: e.target.value
                  }
                })
              }}
              onBlur={() => handleBlur('secondEmail')}
              error={validFields.secondEmail.hasError}
              supportText={t('validation-email')}
            />

          </div>

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={10}
            xl={10}
            className={styles['edit-name-buttons']}
          >
            <Button
              text={t('button-save-changes')}
              buttonStyle="cta-red-oval-edit-profile"
              onClick={handleSubmit}
              disabled={!isFormValid}
            />
            <Button
              text={t('button-cancel')}
              buttonStyle="filled-grey-oval"
              onClick={onCancel}
            />
          </Grid>
        </div>

        <div className={styles['JNJ-footer']}>
          <JNJFooter />
        </div>
      </LoadingIcon>
    </MarginWrapper>

  )
}

EditSecondaryEmailMobile.propTypes = {
  t: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  userFields: PropTypes.shape({
    email: PropTypes.string,
    secondEmail: PropTypes.string,
  }).isRequired,
  validFields: PropTypes.shape({
    email: PropTypes.shape({
      isValid: PropTypes.bool,
      hasError: PropTypes.bool,
    }),
    secondEmail: PropTypes.shape({
      isValid: PropTypes.bool,
      hasError: PropTypes.bool,
    }),
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isFormValid: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  secondaryEmailRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.oneOfType([
        PropTypes.instanceOf(HTMLInputElementType),
        PropTypes.oneOf([null]),
      ]),
    }),
  ]).isRequired
}

export default EditSecondaryEmailMobile
